import { html, Html, View } from 'rune-ts';
import { ProductCardView } from '../../ProductCard/ProductCardView.ts';

type ProductCardItemViewData = {
  cardView: ProductCardView;
  options?: {
    klass?: string;
  };
};

export class ProductCardItemView extends View<ProductCardItemViewData> {
  public readonly product_id: number;
  public readonly ordered_at: Date | null;
  private readonly cardView: ProductCardView;

  constructor(data: ProductCardItemViewData) {
    super(data);
    this.cardView = data.cardView;
    this.product_id = data.cardView.data.id;
    this.ordered_at = data.cardView.data.ordered_at ?? null;
  }

  protected override template(): Html {
    const klass = this.data.options?.klass || '';

    return html`<li class="${klass}">${this.cardView}</li>`;
  }

  public fadeIn() {
    return this.cardView.fadeIn();
  }
}
